exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".label-editor-kind-select {\n  min-width: 125px;\n}\n", ""]);

